import React from 'react';
import { MAX_LIST_SIZE } from '../constants';
import { DrawerPoint } from '../types';

interface Props {
    label: string;
    /** 徽标前缀: 进门点="门", 停车点="P"。 */
    badgePrefix: string;
    badgeColor: string;
    points: DrawerPoint[];
    /** 该编辑器是否处于"地图选点"态。 */
    picking: boolean;
    /** 只读模式 (无编辑权限)。 */
    readonly?: boolean;
    onTogglePick: () => void;
    onRemove: (idx: number) => void;
}

/**
 * 进门点 / 停车点 列表编辑器 (对齐原型): 每行 徽标 + 坐标 + ✕, 底部虚线按钮进入地图选点态。
 */
const PointListEditor: React.FC<Props> = ({
    label,
    badgePrefix,
    badgeColor,
    points,
    picking,
    readonly = false,
    onTogglePick,
    onRemove,
}) => (
    <div>
        <label className="mb-2 block text-sm" style={{ color: 'rgba(0,0,0,.88)' }}>
            {label}
            <span style={{ color: '#a5adb9', fontWeight: 500 }}>（可多个）</span>
        </label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {points.map((p, i) => (
                <div
                    key={`${p.lng}-${p.lat}-${i}`}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        height: 34,
                        padding: '0 5px 0 8px',
                        border: '1px solid #e5e9f0',
                        borderRadius: 8,
                        background: '#f7f9fc',
                    }}
                >
                    <span
                        style={{
                            flex: 'none',
                            height: 19,
                            padding: '0 7px',
                            borderRadius: 10,
                            background: badgeColor,
                            color: '#fff',
                            fontSize: 10.5,
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {badgePrefix}{i + 1}
                    </span>
                    <span className="flex-1 text-xs text-gray-600">
                        {p.lat.toFixed(5)}, {p.lng.toFixed(5)}
                    </span>
                    {!readonly && (
                        <button
                            type="button"
                            title="删除"
                            onClick={() => onRemove(i)}
                            style={{
                                flex: 'none',
                                width: 24,
                                height: 24,
                                border: 'none',
                                borderRadius: 6,
                                background: 'transparent',
                                color: '#a5adb9',
                                fontSize: 13,
                                cursor: 'pointer',
                            }}
                        >✕</button>
                    )}
                </div>
            ))}
            {!readonly && (
                <button
                    type="button"
                    onClick={onTogglePick}
                    disabled={points.length >= MAX_LIST_SIZE}
                    style={{
                        height: 34,
                        border: `1px dashed ${picking ? '#1677ff' : '#cdd6e2'}`,
                        borderRadius: 8,
                        background: picking ? '#e6f4ff' : '#fff',
                        color: picking ? '#1677ff' : 'rgba(0,0,0,.65)',
                        fontWeight: 600,
                        fontSize: 12,
                        cursor: points.length >= MAX_LIST_SIZE ? 'not-allowed' : 'pointer',
                    }}
                >
                    {picking ? '点地图添加，完成后点此结束' : `＋ 地图选点添加${label}`}
                </button>
            )}
        </div>
    </div>
);

export default PointListEditor;
